import '../../css/pages/home.less'
import '../../css/pages/home_tpl_1.less'
import '../../css/pages/home_tpl_10.less'
import '../../css/pages/home_tpl_12.less'
import '../../css/pages/home_tpl_16.less'
import '../../css/pages/home_tpl_2.less'
import '../../css/pages/home_tpl_5.less'
import '../../css/pages/home_tpl_7.less'
import '../../css/pages/home_tpl_8.less'
import '../../css/pages/home_tpl_17.less'
import '../../css/pages/home_tpl_18.less'
import '../../css/pages/shanxishangmao_resourceTopic.less'
new Vue({
    el: '#app',
    data: function () {
        this.previewPlayer = null
        return {
            prefix,
            browserTabAbbreviation,
            recommendedCourses: [],
            recommendedCoursesLoading: false,
            recommendedInfo: [],//推荐课程
            recommendedInfoLoading: false,
            recommendedKnowledge: [],//推荐知识点
            recommendedKnowledgeLoading: false,
            todayKnowledge: {},//今日知识点
            todayKnowledgeMenuActive: true,
            todayKnowledgeItemActive: '',
            previewFile: {},//今日知识点预览信息
            permissionList: [],
            topLeftActive: '1',
            headActive: true,
            swipers: {},
            stretchActive: false,
            departmentList: [],
            subjectList: [],
            noticeList: [],
            bannerBoxLimit: 15,
            subjectBoxLimit: 13,
            bannerBoxMargin: 0,
            bannerHeight: 0,
            bannerPlateType,
            showName: false,
            scrollNavStatus: true,//开启页面滚动监听控制导航样式
            closeSystemNotice: !!sessionStorage.getItem('closeSystemNotice'),
            bannerName: 'banner_1.jpg',
            hideNavSearch: false,
            subjectActive: false,//专题板块样式
            showSubject: false,//是否显示专题板块
            dachuanPlateList: {},//五大专题课程
            homeSubjectType: 0,//五大专题样式，1-川大，2-杭师大
            ifTop0: true,
            infomationTabActive: '',
            infomationTabs: [
                {
                    label: '思政育人',
                    value: 'szyr'
                }, {
                    label: '总师文化',
                    value: 'zswh'
                }, {
                    label: '师德师风',
                    value: 'sdsf'
                }, {
                    label: '党政学习',
                    value: 'dzxx'
                }
            ],
            infomationList: [],
            infomationActive: 0,
            theme_8: {
                //中医大
                bannerDrawer: {
                    left: true,
                    right: true
                },
                recommendCourse: [],
                statistics: {}
            },
            theme_10: {
                //云大
                statistics: {}
            },
            courseData,
            sxInput: '', // 陕西商贸搜索框
            sxsmSourceList: [ // 陕西商贸资源列表(写死)
                {
                    icon: '/learn/static/imgs/shanxishangmao/course_bg.png',
                    englishName: 'Curriculum',
                    name: '课程',
                    tagColor: '#3074ED',
                    count: '36',
                    unit: '门',
                    linkUrl: '/learn/search',
                },
                {
                    icon: '/learn/static/imgs/shanxishangmao/knowledge_bg.png',
                    englishName: 'Knowledge points',
                    name: '知识点',
                    tagColor: '#FF8A35',
                    count: '148',
                    unit: '个',
                    linkUrl: '/learn/resources/search?searchType=3',
                },
                {
                    icon: '/learn/static/imgs/shanxishangmao/audio_bg.png',
                    englishName: 'Audio and Video',
                    name: '音视频资源',
                    tagColor: '#1EBC87',
                    count: '206',
                    unit: '个',
                    linkUrl: '/learn/resources/search?searchType=0&page=1&size=30&resourcesType=0&resourcesInfoType=-1&timeType=-1&isDesc=true',
                },
                {
                    icon: '/learn/static/imgs/shanxishangmao/document_bg.png',
                    englishName: 'Document Resources',
                    name: '文档资源',
                    tagColor: '#5B44F7',
                    count: '1068',
                    unit: '个',
                    linkUrl: '/learn/resources/search?searchType=0&page=1&size=30&resourcesType=3&resourcesInfoType=-1&timeType=-1&isDesc=true',
                },
                {
                    icon: '/learn/static/imgs/shanxishangmao/aibg.png',
                    englishName: 'AI toolset',
                    name: 'AI工具集',
                    tagColor: '#F6AD00',
                    count: '508',
                    unit: '个',
                    linkUrl: '/learn/resources/search?searchType=0&page=1&size=30&resourcesType=2&resourcesInfoType=-1&timeType=-1&isDesc=true',
                },
            ],
            cnuData: {
                //重庆师范定制数据
                recommendHotCourse: []
            },
            theme_17: {
                homeSubjectSelect: 0,
                homeSubjectList: [
                    {
                        key: '4',
                        url: 'https://video.jw.scut.edu.cn/',
                    },
                    {
                        key: '3',
                        url: 'http://www2.scut.edu.cn/cxcy/main.htm',
                    },
                    {
                        key: '2',
                        url: 'http://222.16.5.91/xm/CXCY/SCUT',
                    },
                    {
                        key: '1',
                        url: 'https://bbtxt.scut.edu.cn/learn/search?subjectId=&college=&professionIds=&courseType=-1&platform=%E6%99%BA%E6%85%A7%E8%AF%BE%E7%A8%8B&classificationId=&semester_teaching_courses=&courseState=0&field=publishTime&isDesc=true&tag=&page=1&size=15&subjectCategories=&',
                    },
                ]
            },
            topicList: {},
            isMore:{  }
        }
    },
    updated: function () {
    },
    watch: {
        sysModules: {
            async handler(newVal) {
                //五大专题配置
                let { value } = newVal.find(el => el.code == 'home_subject_show') || {}
                if (value == '1' || value == 'true') {
                    //川大版本
                    this.showSubject = true
                    this.subjectActive = true
                    this.homeSubjectType = 1
                } else if (value == '2') {
                    //杭师大版本
                    this.showSubject = true
                    this.subjectActive = true
                    this.homeSubjectType = 2
                } else if (value == '3') {
                    //西南交大版本
                    this.showSubject = true
                    this.subjectActive = true
                    this.homeSubjectType = 3
                } else if (value == '4') {
                    //长安大学版本
                    this.showSubject = true
                    this.subjectActive = true
                    this.homeSubjectType = 4
                }
                if (value != '0' && value != 'false') {
                    this.subjectInit()
                } else {
                    this.subjectInit(false)
                }
                //获取排除学院列表
                let excludeDeps = newVal.filter(el => el.code == 'exclude_department_list')
                excludeDeps = excludeDeps.length ? excludeDeps[0].value : ''
                excludeDeps = excludeDeps.split(/[',','，']/)
                await this.getDepartmentList()
                this.departmentList = this.departmentList.filter(el => {
                    return !excludeDeps.includes(el.name)
                });
            },
            deep: true
        },
    },
    directives: {
        title_color: {
            update: (el) => {
                // 聚焦元素
                let txt = el.innerHTML
                if (!txt) return
                let str = txt
                if (txt.length == 4) {
                    str = `<span>${txt.slice(0, 2)}</span><span style="color: #FF6823">${txt.slice(-2)}</span>`
                } else if (txt.length == 6) {
                    str = `<span>${txt.slice(0, 2)}</span><span style="color: #FF6823">${txt.slice(-4)}</span>`
                } else if (txt.length == 7) {
                    str = `<span>${txt.slice(0, 3)}</span><span style="color: #FF6823">${txt.slice(-4)}</span>`
                }
                el.innerHTML = str
            }
        }
    },
    mounted() {
        let that = this
        //获取资讯
        that.handleInfomationTab(that.infomationTabs[0].value)
        that.$nextTick(() => {
            setTimeout(() => {
                for (let key in that.swipers) {
                    if (that.swipers[key]) {
                        try {
                            that.swipers[key].destroy(false)
                        } catch {
                        }
                    }
                }
                that.swiperInitAll()
                //监听尺寸改变事件
                window.addEventListener('resize', that.debounce(that.resize, 100))
            }, 300)
        })
        this.getNotifationList()
        if (that.bannerPlateType == 5 || that.bannerPlateType == 18) {
            that.getBannerName()
            this.hideNavSearch = true
        }
        this.$on('ready', async () => {
            //推荐知识点
            if (that.courseData && that.courseData.sortCourse && that.courseData.sortCourse.find(el => el.type == 'recommendedCourses')) {
                //推荐课程
                that.handleRefreshCourse()
            }
            if (that.courseData.sortCourse && that.courseData.sortCourse.find(el => el.type == 'recommendedInfo')) {
                that.getTodayKnowledge()
                that.handleRefreshKnowledge()
            }
            //初始化开课学院、学科默认选中tab
            if (!this.sysModulesFormat.includes('show_course_school')) {
                this.topLeftActive = '2'
            }
            if (this.targetCustomer == 'cnu') {
                //重庆师范，获取点击率最热推荐数据
                this.getRecommendHotCourse()
            }

        })
        this.getIfTop0({})
        if (this.bannerPlateType == 8) {
            //获取首页推荐课程
            this.getRecommednCourse()
        }
        if (this.bannerPlateType == 10) {
            //云大首页统计数据
            this.getYnuStatisticsData()
        }
        //获取陕西商贸门户数据
        this.resourceStatistic()
        this.getShowName()
        this.getResourceCourse();
    },
    methods: {
        handleTopicClick(item) {
            window.open(`/rman/#/basic/rmanDetail/${item.contentId_}?hidebtn=true&isSysAuth=true`)
        },
        getResourceCourse()  {
            let topicCode
            let sortCourse = this.courseData.sortCourse;
            console.log(sortCourse,'sortCourse')
            //todo 这个需要改为true
            let resourceTopics = sortCourse.filter(item => item.isResourceTopic);
            console.log(resourceTopics,'resourceTopics')
            if (resourceTopics.length > 0) {
                // topicCode = resourceTopics[0].code;
                resourceTopics.forEach(el => {
                    console.log(el)
                  this.getResourceItemData(el.code, el.size,1).then(res => {
                      console.log(res)
                      this.topicList[el.code] = res.data
                      this.isMore[el.code] = res.pageInfo.total > res.pageInfo.size
                  })
                })
            }
        },
        //获取资源专题数据
        getResourceItemData(topicCode,size,page){
            return new Promise((resolve, reject) => {
                API.reqResourceCourse(topicCode, page, size || 5).then(res => {
                    if (res && res.status === 200) {
                        resolve({data:res.data.results,pageInfo: { size: res.data.size,total: res.data.total }})
                    }
                }).catch(err => {
                    reject(err)
                })
            })

        },
        resourceStatistic() {
            API.resourceStatisticData().then(res => {
                if (res && res.data) {
                    console.log(res.data);
                    let list = res.data
                    console.log(list.biz_sobey_audio ?? 0, list.biz_sobey_video ?? 0);
                    this.sxsmSourceList = [ // 陕西商贸资源列表(写死)
                        {
                            icon: '/learn/static/imgs/shanxishangmao/course_bg.png',
                            activeIcon: '/learn/static/imgs/shanxishangmao/course_bg_active.png',
                            englishName: 'Curriculum',
                            name: '课程',
                            tagColor: '#3074ED',
                            count: list.course ?? 0,
                            unit: '门',
                            linkUrl: '/learn/search',
                        },
                        {
                            icon: '/learn/static/imgs/shanxishangmao/knowledge_bg.png',
                            activeIcon: '/learn/static/imgs/shanxishangmao/knowledge_bg_active.png',
                            englishName: 'Knowledge points',
                            name: '知识点',
                            tagColor: '#FF8A35',
                            count: list.knowledge_point ?? 0,
                            unit: '个',
                            linkUrl: '/learn/resources/search?searchType=3',
                        },
                        {
                            icon: '/learn/static/imgs/shanxishangmao/audio_bg.png',
                            activeIcon: '/learn/static/imgs/shanxishangmao/audio_bg_active.png',
                            englishName: 'Multimedia Resources',
                            name: '图片•音视频',
                            tagColor: '#1EBC87',
                            count: (list.biz_sobey_audio ?? 0) + (list.biz_sobey_video ?? 0),
                            unit: '个',
                            linkUrl: '/learn/resources/search?searchType=0&page=1&size=30&resourcesType=2&resourcesInfoType=-1&timeType=-1&isDesc=true',
                        },
                        {
                            icon: '/learn/static/imgs/shanxishangmao/document_bg.png',
                            activeIcon: '/learn/static/imgs/shanxishangmao/document_bg_active.png',
                            englishName: 'Document Resources',
                            name: '文档资源',
                            tagColor: '#5B44F7',
                            count: list.biz_sobey_document ?? 0,
                            unit: '个',
                            linkUrl: '/learn/resources/search?searchType=0&page=1&size=30&resourcesType=3&resourcesInfoType=-1&timeType=-1&isDesc=true',
                        },
                        {
                            icon: '/learn/static/imgs/shanxishangmao/aibg.png',
                            activeIcon: '/learn/static/imgs/shanxishangmao/aibg_active.png',
                            englishName: 'AI toolset',
                            name: 'AI工具集',
                            tagColor: '#F6AD00',
                            count: list.biz_sobey_picture ?? 0,
                            unit: '个',
                            linkUrl: '/aitools/#/overview',
                        },
                    ]
                }
            })
        },
        // 陕西商贸搜索框点击
        handleSxSearchBtn() {
            if (!this.sxInput) {
                return this.$message.warning('请输入搜索内容！')
            } else {
                // 点击时间埋点
                window.depthStatistics({
                    platform: 'aplus_queue',
                    params: { action: 'aplus.record', arguments: ['search_click', 'CLK', { keyword: this.sxInput }] }
                })
                location.href = location.origin + '/learn/global/search?keyword=' + this.sxInput
            }
        },
        getShowName() {
            API.reqUserInfo().then(res => {
                if (res.data) {
                    res.data.moduleCode.extendMessage.map(item => {
                        if (item.code == 'is_show_platform_name') {
                            this.showName = item.value
                            return
                        }
                    })
                }
            }).catch((err) => console.info(err))
        },
        numberFormat(num) {
            if (num > 10000) {
                return (num / 10000).toFixed(2) + '万'
            } else {
                return num
            }
        },
        numberFormatObj(number) {
            let unit = ''
            if (number > 10000) {
                number = (number / 10000).toFixed(2)
                unit = '万'
            }
            return {
                number,
                unit
            }
        },
        getRecommednCourse() {
            API.reqHomeRecommendCourse().then(data => {
                if (data && data.length) {
                    this.theme_8.recommendCourse = data
                }
            })
            API.reqHomeCourseStatistics().then(res => {
                if (res.status == 200) {
                    this.theme_8.statistics = res.data || {}
                }
            })
            new Swiper('.other_swiper_container', {
                loop: true, // 循环模式选项
                autoplay: false,
                // 如果需要分页器
                navigation: {
                    nextEl: '.other-swiper-button-next',
                    prevEl: '.other-swiper-button-prev',
                },
            })
        },
        getYnuStatisticsData() {
            API.reqHomeCourseStatistics().then(res => {
                if (res.status == 200) {
                    this.theme_10.statistics = {
                        ...this.theme_10.statistics, // 默认值
                        totalCourses: this.numberFormatObj(res.data.totalCourses || 0).number,
                        totalCoursesUnit: this.numberFormatObj(res.data.totalCourses || 0).unit,
                        totalLoginTimes: this.numberFormatObj(res.data.totalLoginTimes || 0).number,
                        totalLoginTimesUnit: this.numberFormatObj(res.data.totalLoginTimes || 0).unit,
                        totalLoginTeachers: this.numberFormatObj(res.data.totalLoginTeachers || 0).number,
                        totalLoginTeachersUnit: this.numberFormatObj(res.data.totalLoginTeachers || 0).unit,
                        totalLoginStudents: this.numberFormatObj(res.data.totalLoginStudents || 0).number,
                        totalLoginStudentsUnit: this.numberFormatObj(res.data.totalLoginStudents || 0).unit,
                    }
                }
            })
            API.reqResourceStatistics().then(res => {
                if (res.statusCode == 200) {
                    this.theme_10.statistics = {
                        ...this.theme_10.statistics, // 默认值
                        totalResource: this.numberFormatObj(res.data.total || 0).number,
                        totalResourceUnit: this.numberFormatObj(res.data.total || 0).unit,
                    }
                }
            })
            new Swiper('.other_swiper_container', {
                loop: true, // 循环模式选项
                autoplay: false,
                // 如果需要分页器
                navigation: {
                    nextEl: '.other-swiper-button-next',
                    prevEl: '.other-swiper-button-prev',
                },
            })
        },
        debounce(func, delay = 0) {
            if (typeof func !== 'function') throw new TypeError('need a function');
            let timer = null;
            return function () {
                if (timer) clearTimeout(timer);
                timer = setTimeout(() => {
                    func.apply(this, arguments);
                    timer = null;
                }, delay);
            };
        },
        resize() {
            const that = this
            // that.swiperInitAll()
            if (bannerPlateType == '5' || bannerPlateType == '18') {
                //获取banner高度
                this.bannerHeight = (document.getElementsByClassName('top_wrap')[0] || {}).clientHeight
            } else if (document.querySelector('.top_wrap_1 .right .el-tabs__content')) {
                //川大首页
                try {
                    let h = document.querySelector('.top_wrap_1 .right .el-tabs__content').clientHeight
                    that.bannerBoxMargin = parseInt(h / 24)
                    that.bannerBoxLimit = ((parseInt(h / 19)) % 2 == 0) ? ((parseInt(h / 19)) - 1) : (parseInt(h / 19))
                    that.subjectBoxLimit = ((parseInt(h / 25)) % 2 == 0) ? (parseInt((h / 25) - 1)) : (parseInt(h / 25))
                } catch {
                }
                //获取banner高度
                this.bannerHeight = (document.getElementsByClassName('top_wrap')[0] || {}).clientHeight
            }
            //初始化五大专题排布
            this.homeSubjectPositonInit()
        },
        swiperInitAll: function () {
            this.bannerSwiperInit()
            this.courseReviewSwiperInit()
            // this.courseListSwiperInit()
            // this.noticeSwiperInit()
            this.platformSwiperInit()
        },
        bannerSwiperInit: function () {
            this.swipers.bannerSwiper = new Swiper('.swiper_container', {
                loop: true, // 循环模式选项
                autoplay: true,
                // 如果需要分页器
                pagination: {
                    el: '.banner_swiper_pagination',
                },
            })
        },
        courseReviewSwiperInit: function () {
            this.swipers.courseReviewSwiper = new Swiper('.course_review_list', {
                spaceBetween: 25,
                slidesPerView: 'auto',
                slidesPerGroup: 4,
            })
        },
        courseListSwiperInit: function () {
            let that = this
            jQuery('.spec_swiper').each(function (index) {
                that.swipers[`spec_swiper_${index}`] = new Swiper(this, {
                    spaceBetween: 25,
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                })
            })
        },
        noticeSwiperInit: function () {
            this.swipers.noticeSwiper = new Swiper('.notice_swiper_container', {
                direction: 'vertical',
                loop: true, // 循环模式选项
                autoplay: true,
            })
        },
        platformSwiperInit: function () {
            const that = this
            let rowHeight = 60
            let rowNumber = parseFloat((this.sysModules.find(el => el.code == 'course_platform_row_number') || {}).value || 0)
            if (rowNumber) {
                jQuery('.platform_wrap_2 .platform_content').css({ height: rowHeight * rowNumber })
                //初始化翻页功能
                jQuery('.platform_wrap_2 .swiper-button-prev').click(function () {
                    //上一页
                    let top = jQuery('.platform_wrap_2 .platform_content').scrollTop()
                    if (top <= 0) return
                    // console.log(jQuery('.platform_wrap_2 .platform_content').animate({ scrollTop: top - rowHeight }, '300'))
                })
                jQuery('.platform_wrap_2 .swiper-button-next').click(function () {
                    //下一页
                    let top = jQuery('.platform_wrap_2 .platform_content').scrollTop()
                    // console.log(jQuery('.platform_wrap_2 .platform_content').animate({ scrollTop: top + rowHeight }, '300'))
                })
            }
        },
        //推荐知识点换一换
        handleRefreshKnowledge() {
            this.recommendedKnowledgeLoading = true
            API.reqHomePageRecommend({ user_code: this.loginUserInfo ? this.loginUserInfo.user_code : 'null', rec2_type: 'rec2_recommended_knowledge' }).then(res => {
                if (res.error_code == 'sc-rec-service.0000.0000') {
                    this.recommendedKnowledge = (res.extend_message || []).map(el => {
                        if (el.nodeValue) {
                            return {
                                ...el,
                                nodeValue: JSON.parse(el.nodeValue)
                            }
                        } else {
                            return {
                                ...el,
                            }
                        }
                    })
                    // console.log(this.recommendedKnowledge)
                }
            }).finally(() => {
                this.recommendedKnowledgeLoading = false
            })
        },
        //今日知识点
        getTodayKnowledge() {
            API.reqHomePageRecommend({ user_code: this.loginUserInfo ? this.loginUserInfo.user_code : 'null', rec2_type: 'rec2_daily_knowledge', rec2_num: 1 }).then(res => {
                if (res.error_code == 'sc-rec-service.0000.0000') {
                    let data = res.extend_message ? res.extend_message[0] : {}
                    if (data?.rec_reason == '知识点推荐') {
                        //知识点推荐
                        data.type = 'knowledge'
                        if (data.nodeValue) {
                            data.nodeValue = JSON.parse(data.nodeValue)
                        }
                        data.others = []
                        if (data.parentNodeName) {
                            data.others.push({
                                label: this.$t('前序知识点'),
                                value: data.parentNodeName
                            })
                        }
                        if (data.nextNodeName) {
                            data.others.push({
                                label: this.$t('后序知识点'),
                                value: data.nextNodeName
                            })
                        }
                        if (data.nodeValue.referenceMaterials && data.nodeValue.referenceMaterials.length) {
                            data.others.push({
                                key: 'reference',
                                label: this.$t('参考资料') + '：',
                                value: data.nodeValue.referenceMaterials.map(el => el.name).join(',')
                            })
                        }
                        this.todayKnowledge = data
                        // console.log(this.todayKnowledge)
                        if (this.todayKnowledge.nodeValue && this.todayKnowledge.nodeValue.bindresource && this.todayKnowledge.nodeValue.bindresource.length) {
                            this.handleKnowledgeChange(this.todayKnowledge.nodeValue.bindresource[0])
                        }
                    } else if (data?.rec_reason == '知识点片段') {
                        //知识点片段
                        data.type = 'knowledgePart'
                        this.todayKnowledge = data
                    } else if (data?.entityData) {
                        //微课
                        data = data.entityData
                        data.type = 'micro'
                        this.todayKnowledge = data
                        if (this.todayKnowledge.courseResources && this.todayKnowledge.courseResources.length) {
                            this.handleKnowledgeChange(this.todayKnowledge.courseResources[0])
                        }
                    }
                }
            })
        },
        //切换知识点播放
        async handleKnowledgeChange(info) {
            // console.log(info)
            const that = this
            that.todayKnowledgeMenuActive = false
            that.todayKnowledgeItemActive = info.contentId
            if (info.type == 'biz_sobey_point' || (info.type == 'biz_sobey_picture' && info.keyframe_)) {
                this.previewFile = {
                    ...info,
                    src: info.keyframe_
                }
                return
            }
            await API.reqFileInfo([info.contentId]).then(res => {
                if (res.status == 200 && res.data.length) {
                    let data = res.data[0]
                    if (data.type == 'biz_sobey_picture') {
                        this.previewFile = {
                            ...info,
                            src: res.data[0].filePath
                        }
                    } else if (data.type == 'biz_sobey_video') {
                        this.previewFile = {
                            ...info,
                            type: 'biz_sobey_video',
                            src: res.data[0].filePath
                        }
                        this.$nextTick(() => {
                            this.previewVideoInit()
                        })
                    } else if (data.type == 'biz_sobey_document') {
                        this.previewFile = info
                        that.$nextTick(() => {
                            that.docPreviewInit(res.data[0].filePath)
                        })
                    }
                } else {
                    this.previewFile = {
                        ...info,
                        type: 'not_suport'
                    }
                }
            }).catch(() => {
                this.previewFile = {
                    ...info,
                    type: 'not_suport'
                }
            })
        },
        //今日知识点预览视频
        previewVideoInit() {
            if (this.previewPlayer) {
                this.previewPlayer.destroy();
            }
            let url = this.previewFile.src
            let option = {
                id: 'preview_player',
                url,
                // fluid: true,//流式布局
                width: '100%',
                height: '100%',
                controlslist: "nodownload",
                autoplay: true,
                videoInit: true,//初始化显示首帧
            }
            if (url && url.split('?')[0].includes('.flv')) {
                this.previewPlayer = new FlvJsPlayer(option);
            } else if (url && url.split('?')[0].includes('.m3u8')) {
                this.previewPlayer = new HlsJsPlayer(option);
            } else {
                this.previewPlayer = new Player(option);
            }
        },
        //推荐课程换一换
        handleRefreshCourse() {
            this.recommendedCoursesLoading = true
            let rec2_num = 4
            if (this.bannerPlateType == 18) {
                rec2_num = 6
            }
            API.reqHomePageRecommend({ user_code: this.loginUserInfo ? this.loginUserInfo.user_code : 'null', rec2_type: 'rec2_recommended_course', rec2_num }).then(res => {
                if (res.error_code == 'sc-rec-service.0000.0000') {
                    this.recommendedCourses = res.extend_message
                }
            }).finally(() => {
                this.recommendedCoursesLoading = false
            })
        },
        docPreviewInit(filePath) {
            const that = this;
            const filepath = filePath;
            const filename = decodeURIComponent(common.getFileNameByPath(filepath));
            const fileType = common.getFileTypeByPath(filepath);
            const key = Date.now().toString();
            const documentType = common.getDocumentType(fileType);
            const url = filepath.includes("http") ? filepath : location.origin + filepath;
            const config = {
                document: {
                    fileType,
                    key,
                    title: filename,
                    url,
                    permissions: {
                        print: false,
                        download: false
                    }
                },
                documentType,
                height: "100%",
                type: "desktop",//desktop mobile embedded
                width: "100%",
                lang: "zh-cn",
                editorConfig: {
                    // "coEditing": {
                    //     "mode": "fast",
                    //     "change": true
                    // },
                    lang: "zh-cn",
                    region: "zh-CN",
                    location: "cn",
                    mode: that.getIfPc() ? "view" : 'mobile',//view edit
                    user: {
                        // "group": "Group1",
                        id: this.loginUserInfo ? this.loginUserInfo.user_code : 'youke',
                        name: this.loginUserInfo ? this.loginUserInfo.nick_name : '游客'
                    },
                    // "plugins": {},
                    customization: {
                        help: false,
                        hideNotes: true,
                        comments: true,
                        chat: false,
                        integrationMode: "embed",
                        logo: {
                            image: "/documentserver/web-apps/apps/common/main/resources/img/header/header-logo_s.png",
                            imageDark: "/documentserver/web-apps/apps/common/main/resources/img/header/dark-logo_s.png",
                            url: "http://www.sobey.com"
                        },
                        uiTheme: "theme-classic-light",//theme-light, theme-classic-light, theme-dark, theme-contrast-dark default-dark, default-light default:theme-classic-light
                    }
                },
            }
            config.token = common.jwtSign(config, "tUVvbKk2mX4T40MBRrtj");
            // console.log(config)
            this.$nextTick(() => {
                setTimeout(() => {
                    window.loadScript('/documentserver/web-apps/apps/api/documents/api.js').then(() => {
                        new DocsAPI.DocEditor("document-container", config);
                    })
                }, 2000)
            })
        },
        durationFormat(dur) {
            var theTime = parseInt(dur / 10000000 || 0);// 秒
            var minuetes = 0;// 分
            var hour = 0;// 小时

            if (theTime >= 60) {
                minuetes = parseInt(theTime / 60);
                theTime = parseInt(theTime % 60);
                if (minuetes >= 60) {
                    hour = parseInt(minuetes / 60);
                    minuetes = parseInt(minuetes % 60);
                }
            }
            theTime = theTime < 10 ? '0' + theTime : theTime
            var result = "" + theTime;
            minuetes = minuetes < 10 ? '0' + minuetes : minuetes
            result = "" + minuetes + ":" + result;
            if (hour > 0) {
                result = "" + parseInt(hour) + ":" + result;
            }
            return result;
        },
        stretchChange() {
            this.stretchActive = !this.stretchActive
        },
        getDepartmentList() {
            return new Promise((resolve, reject) => {
                let that = this
                API.reqCourseCategories().then(res => {
                    if (res.status == 200) {
                        that.departmentList = res.data.organization
                        that.subjectList = res.data.subjectEducation
                        that.$nextTick(() => {
                            that.resize()
                        })
                    }
                }).finally(() => resolve())
            })
        },
        handleCloseNotice() {
            sessionStorage.setItem('closeSystemNotice', true)
            this.closeSystemNotice = true
        },
        getNotifationList() {
            const that = this
            API.reqNotifacationList().then(res => {
                // console.log(res)
                if (res.errorCode == 'success' && res.extendMessage) {
                    this.noticeList = (res.extendMessage.results || []).filter(el => el.msgState).map(el => ({ ...el, content: el.content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '') }))
                    this.$nextTick(() => setTimeout(() => that.noticeSwiperInit(), 200))
                }
            })
        },
        getBannerName() {
            let r = Math.random
            let random = Math.floor(r() * 5) + 1
            this.bannerName = 'banner_' + random + '.jpg'
        },
        //初始化导航显示
        getIfTop0(e, ifInitSubject) {
            const that = this
            let top = document.querySelector('.home_content').scrollTop
            e = e || window.event;
            let direction = e.wheelDelta
            //大于0向上滚动，小于0向下滚动
            // console.log(top,e)
            setTimeout(() => {
                //加了css动画，会有0.7s动画延时
                top = document.querySelector('.home_content').scrollTop
                if (top == 0) {
                    that.ifTop0 = true
                } else {
                    that.ifTop0 = false
                }
            }, 700);
            if (!ifInitSubject) return //只初始化导航栏
            if (direction > 0 && top == 0) {
                !that.subjectActive && (that.subjectActive = true)
            } else {
                that.subjectActive && (that.subjectActive = false)
            }
            // console.log(that.subjectActive)
        },
        //点击图片跳转
        handleClickImage(item) {
            console.log(item)
            this.theme_17.homeSubjectList.forEach(el => {
                if (el.key == item) {
                    window.open(el.url, '_blank')
                }
            })
        },
        //初始化专题显示
        async subjectInit(ifInitSubject = true) {
            const that = this
            // console.log('初始化专题显示')
            await new Promise((res) => {
                that.$nextTick(() => {
                    that.resize()
                    res()
                })
            })
            await API.reqHomedachuanPlateList().then(res => {
                that.dachuanPlateList = res || {}
                console.log('dachuanPlateList', that.dachuanPlateList)
            })
            mouseWheelFn(document.getElementById('app'), (e) => that.getIfTop0(e, ifInitSubject))
            let startY, direction;
            document.addEventListener("touchstart", (e) => {
                // console.log('touchstart',e);
                startY = e.changedTouches[0].pageY;
            })
            document.addEventListener("touchmove", (e) => {
                //修复移动端初始化前就拖动导致的五大专题重叠问题
                if (document.querySelector('#app').scrollTop > window.innerHeight && that.subjectActive) {
                    that.subjectActive = false
                }
                let dom = document.querySelector('.home_subject_mobile')
                let scrollHeight = dom.scrollHeight
                let clientHeight = dom.clientHeight

                let top = dom.scrollTop
                direction = e.changedTouches[0].pageY - startY;
                //取100是为了避免太灵敏导致误触（滑动banner）
                if (direction > 100) {
                    let contentTop = document.querySelector('.home_content').scrollTop
                    //防止往上滑动即触发
                    if (contentTop >= 20) return
                    !that.subjectActive && (that.subjectActive = true)
                } else if (direction < -100) {
                    // if (scrollHeight - clientHeight - top > 100) return
                    that.subjectActive && (that.subjectActive = false)
                }
            })

            this.$nextTick(() => {
                setTimeout(() => {
                    jQuery('.home_content').css({ transition: 'transform 0.7s ease-in-out' })
                }, 10)
                setTimeout(() => {
                    jQuery('.subject_bg').css({ position: 'absolute' })
                }, 700);
            })
        },
        getCourseTargetHref(course) {
            return this.prefix + (course.type_ == 'biz_sobey_course' ?
                'course/micro/' :
                (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 1) ?
                    'course/preview/mooc/' :
                    (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 2) ?
                        'course/preview/spoc/' :
                        'course/preview/thirdparty/') + course.contentId_
        },
        sleep(timeout) {
            return new Promise((res) => setTimeout(() => res(), timeout))
        },
        async homeSubjectPositonInit() {
            const that = this
            let num = 5
            if (this.homeSubjectType == 4) {
                num = 4
                return
            }
            let subjectItems = jQuery('.home_subject .subject_item')
            subjectItems.css({ width: `calc((100% - 60px - 2vw * 4) / ${num})` })
            if (!subjectItems && !subjectItems.length) return
            //总宽度
            let containerWidth = jQuery('.home_subject').width()
            //单个item宽度
            let itemWidth = jQuery(subjectItems[0]).width()
            //左右边距
            let padding = 60
            //间距
            let gap = (containerWidth - padding * 2 - itemWidth * num) / (num - 1)
            subjectItems.each((i, el) => {
                jQuery(el).css({
                    left: padding + i * (gap + itemWidth) + 'px'
                })
            });
            //初始化hover事件
            (function () {
                let hasLeave = false
                let timeouts = []
                jQuery('.subject_item').unbind('mouseenter')
                jQuery('.subject_item').unbind('mouseleave')
                jQuery('.subject_item').on('mouseenter', async function () {
                    hasLeave = false
                    jQuery('.home_subject .subject_item').animate().stop()
                    jQuery(this).addClass('active')
                    let before = []
                    let after = []
                    let ifAfter = false
                    let currentIndex = 0
                    let transition = 0.05
                    jQuery('.home_subject .subject_item').each((i, el) => {
                        if (jQuery(el).hasClass('active')) {
                            ifAfter = true
                            currentIndex = i
                        } else {
                            if (ifAfter) {
                                after.push(el)
                            } else {
                                before.push(el)
                            }
                        }

                    })
                    after = after.reverse()
                    jQuery(this).css({
                        width: itemWidth + gap * 13 + 'px'
                    })
                    if (!after.length) {
                        //hover最后一个
                        jQuery(this).animate({
                            marginLeft: `${-currentIndex * gap * 3}px`,
                        }, 0.3, 'linear')
                        before.forEach((el, i) => {
                            let timeout = setTimeout(() => {
                                // console.log(jQuery(el))
                                jQuery(el).animate({
                                    marginLeft: `${-i * gap * 3}px`
                                }, transition, 'linear')
                            }, (before.length + 1 - i) * 150);
                            timeouts.push(timeout)
                        })
                    } else {
                        jQuery(this).animate({
                            marginLeft: `${-currentIndex * gap * 4}px`,
                        }, transition, 'linear')
                        // console.log(before, after)
                        before.forEach((el, i) => {
                            let timeout = setTimeout(() => {
                                // console.log(jQuery(el))
                                if (hasLeave) return
                                jQuery(el).animate({
                                    marginLeft: `${-i * gap * 4}px`
                                }, transition, 'linear')
                            }, (before.length + 1 - i) * 100);
                            timeouts.push(timeout)
                        })
                        after.forEach((el, i) => {
                            let timeout = setTimeout(() => {
                                if (hasLeave) return
                                jQuery(el).animate({
                                    marginLeft: `${i * gap * 4 + gap}px`
                                }, transition, 'linear')
                            }, (after.length - i) * 100);
                            timeouts.push(timeout)
                        })
                    }
                })
                jQuery('.subject_item').on('mouseleave', async function () {
                    hasLeave = true
                    jQuery('.home_subject .subject_item').animate().stop()
                    timeouts.map(el => clearTimeout(el))
                    timeouts = []
                    jQuery(this).removeClass('active')
                    jQuery('.home_subject .subject_item').css({
                        width: itemWidth + 'px'
                    })
                    jQuery('.home_subject .subject_item').each((i, el) => {
                        jQuery(el).animate({ marginLeft: 0 }, 100)
                    })
                })
            })()
        },
        //推荐知识节点点击跳转
        handleRecommendPointNode(courseId, semester, pointNodeId) {
            // console.log(courseId, semester, pointNodeId)
            let params = { courseId, semester, pointNodeId, chooseRole: 0 }
            this.handleGlobalJoinCourse(params).then(res => {
                if (res && res.code == 2 && res.href) {
                    window.open(res.href)
                }
            })
        },
        //推荐知识点片段点击跳转
        handleRecommendPointPart(courseId, semester, sectionId, pointId) {
            // console.log(courseId, semester, sectionId)
            let params = { courseId, semester, sectionId, chooseRole: 0, pointId }
            this.handleGlobalJoinCourse(params).then(res => {
                if (res && res.code == 2 && res.href) {
                    window.open(res.href)
                }
            })
        },
        //切换学习资讯分类
        handleInfomationTab(type) {
            this.infomationTabActive = type
            this.infomationActive = 0
            API.reqLearnInfomation({
                status: 1,
                tagCode: type,
                page: 1,
                size: 3
            }).then(res => {
                if (res.errorCode == 'success') {
                    this.infomationList = res.extendMessage.results
                }
            })
        },
        // 处理陕西商贸门板跳转
        handleSmJupm(data) {
            if (!this.loginUserInfo && data.name != '课程') return this.$message.warning('请先登录')
            const target = location.origin + data.linkUrl
            window.open(target, '_blank')
        },
        //重庆师范获取点击率最热推荐
        getRecommendHotCourse() {
            API.reqCourseList({
                page: 1,
                size: 5,
                field: 'hits',
                isDesc: true,
            }).then(res => {
                if (res.status == 200) {
                    this.cnuData.recommendHotCourse = res.data.results
                }
            })
        },
        //跳转到资源专题详情
        goToResourceTopicDeatils(e) {
            console.log(e.target.dataset)
            const code = e.target.dataset.code
            window.location.href = `/learn/resource/topic/details?code=${encodeURIComponent(code)}&page=1&size=10`
        },
        removeHtmlTag(str) {
            return str.replace(/<[^>]+>/g, "")
        },
    }
})
